module.exports = __webpack_public_path__ + "static/media/404.8f15d175.png";